// src/data/projectData.js

import CircularLiftImage from "../../assets/images/Lifts/CircularLift/circularLift1.png";
// import BoxImg1 from "../../assets/images/project/project-details-img-box-img-1.jpg";
// import BoxImg2 from "../../assets/images/project/project-details-img-box-img-2.jpg";
import circularLiftLargeImage from "../../assets/images/Lifts/CircularLift/left.avif";
import passengerLiftLargeImage from "../../assets/images/Lifts/CircularLift/left.avif";
import standardLiftImage from "../../assets/images/project/standardElevator.jpg";

import standardLiftImage1 from "../../assets/images/project/standardHomeElevator.jpg";
// import projectImg1 from "../assets/images/project/project-2-1.jpg";
import hydraulicElevatorImg1 from "../../assets/images/project/hydraulic.jpg";
import hydraulicElevatorImg2 from "../../assets/images/project/hydraulic.avif";
import passengerElevatorImg1 from "../../assets/images/project/voicelink-main.jpg";
import capsuleLiftImg1 from "../../assets/images/project/Capsule.png";
import capsuleLiftImg2 from "../../assets/images/project/capsule1.jpg";
import capsuleLiftImg3 from "../../assets/images/project/capsule.jpg";
import homeElevatorImg1 from "../../assets/images/project/home-elevators.jpg";
import homeElevatorImg3 from "../../assets/images/project/homeelevators.webp";
import hospitalElevatorImg1 from "../../assets/images/project/hospital.jpg";
import serviceLiftImg1 from "../../assets/images/project/dumbwaiter-lift.jpg";
import goodsLiftImg1 from "../../assets/images/project/goodsLift.jpg";
import carElevatorImg1 from "../../assets/images/project/carelevator.jpg";
import carelevatorImg2 from "../../assets/images/project/carelevator1.webp";
import passengerElevatorImg2 from "../../assets/images/project/passengerLift2.png";
import passengerElevatorImg3 from "../../assets/images/project/passengerLift3.png";
import passengerElevatorImg5 from "../../assets/images/project/passengerElevator1.jpg";
import projectImg1 from "../../assets/images/project/Our-products-410x310-01.jpg";
import classicElevator from "../../assets/images/project/classicElevator1.jpg";
import classicElevatorImg1 from "../../assets/images/project/classicElevator2.jpg";
import projectImg3 from "../../assets/images/project/premiumElevator-01.jpg";
import projectImg4 from "../../assets/images/project/classicElevator.jpg";

import passengerElevatorImg4 from "../../assets/images/project/passengerElevator.jpg";
import homeElevatorImg2 from "../../assets/images/project/homeelevator.jpg";
import premiumElevatorImg2 from "../../assets/images/project/premiumElevators.png";
import projectImg5 from "../../assets/images/project/Our-products-410x310-06.jpg";
import CircularLiftBoxImage1 from "../../assets/images/Lifts/CircularLift/circularLift2.png";
import CircularLiftBoxImage2 from "../../assets/images/Lifts/CircularLift/circularLift3.jpg";

import hospitalElevatorImg2 from "../../assets/images/project/hospital1.jpg";
import hospitalElevatorImg3 from "../../assets/images/project/hospital-elevator.jpg";

import serviceLiftImg2 from "../../assets/images/project/serviceElevators.avif";
import serviceLiftImg3 from "../../assets/images/project/serviceElevators1.avif";

import goodsElevatorImg2 from "../../assets/images/project/goodsElevator.jpg";
import goodsElevatorImg from "../../assets/images/project/goodsElevator.webp";

import carElevatorImg3 from "../../assets/images/project/carElevator3.jpg";

import stackParkingLiftImg1 from "../../assets/images/project/stackparking.jpg";
import stackParkingLiftImg2 from "../../assets/images/project/stackParking2.jpg";

import { speed } from "jquery";
import { effectInit } from "swiper/effect-utils";

const projectList = [
  {
    id: "circular-lift",
    basicInfo: {
      image: projectImg1,
      // content: "360° of smooth elevation",
      liftType: "Circular Elevators",
      tagline: "360° PANORAMIC VIEWS",
      passengerSize: "2 TO 6 PASSENGER",
      speed: "SPEED 0.25 TO 1 MPS",
      efficiency: "\n\n\n\n",
      address: "Dhaka 102, 8000 Sent Behaibior, Road 45, House of Street",
      phone: "+32566 - 800 - 890",
      fax: "1234 - 58963 - 007",
      email: "nafiz1223@gmail.com",
      socialLinks: [
        //     { url: "/blog-details", label: "Instagram", iconClass: "icon-instagram" },
        //     { url: "/blog-details", label: "Facebook", iconClass: "icon-facebook-f" },
        //     { url: "/blog-details", label: "Twitter", iconClass: "icon-Vector" },
        //     { url: "/blog-details", label: "LinkedIn", iconClass: "icon-linkedin-in" },
      ],
      contactImage: circularLiftLargeImage,
    },
    details: {
      mainImage: CircularLiftImage,
      title: "360° PANORAMIC VIEWS",
      text1:
        "A circular elevator transudes sophistication with its panoramic design. Often cylindrical with transparent walls, these elevators enhance architecture and offer an unparalleled ride experience.",
      points: [
        "Elegant Interior Lighting and Bespoke Design.",
        "Energy-Efficient Engineering.",
        "Interactive Touchscreen Panels.",
        "Immersive Acoustic Soundscapes.",
      ],
      additionalImages: [CircularLiftBoxImage1],
      text3: "Experience seamless sophistication with every ascent.",
      tableHeader: "Dimension of Cicular Lift",
      tableData: `<table class="arch-table">
      <thead>
        <tr>
          <th>LOAD</th>
          <th>CAR INSIDE</th>
          <th>LIFT WELL SIZE</th>
          <th>ENTRANCE</th>
        </tr>
         <tr>
          <th>Passenger</th>
          <th>Area (sq mt)</th>
          <th>Diameter</th>
          <th>Width in mm</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>4</td>
          <td>0.77</td>
          <td>1750</td>
          <td>700</td>
        </tr>
        <tr>
          <td>6</td>
          <td>1.10 </td>
          <td>1800</td>
          <td>800</td>
        </tr>
        <tr>
          <td>8</td>
          <td>1.43</td>
          <td>1900</td>
          <td>800</td>
        </tr>
        <tr>
          <td>10</td>
          <td>1.75</td>
          <td>2000</td>
          <td>800</td>
        </tr>
      </tbody>
    </table>`,
      // headerData1: [
      //   {title:  "LOAD", colspan: 1},
      //   {title: "CAR INSIDE", colspan: 1},
      //   {title: "LIFT WELL SIZE", colspan: 1},
      //   {title: "ENTRANCE", colspan: 1},
      // ],
      // headerData2: [
      //   {title:  "Passenger", colspan: 2},
      //   // {title: "Area (sq.m)", colspan: 1},
      //   {title: "Diameter (mm)", colspan: 1},
      //   {title: "Width (mm)", colspan: 1},
      // ],
      // tableData: [
      //   { passenger: "4", area: "0.77", liftWellSize: "1750", entrance: "700" },
      //   { passenger: "6", area: "1.10", liftWellSize: "1800", entrance: "800" },
      //   { passenger: "8", area: "1.43", liftWellSize: "1900", entrance: "800" },
      //   { passenger: "10", area: "1.75", liftWellSize: "2000", entrance: "800" },
      // ],
    },
  },
  {
    id: "passenger-elevators",
    basicInfo: {
      image: passengerElevatorImg1,
      liftType: "Passenger Elevators",
      tagline: "Standard Passenger Rides",
      passengerSize: "2 TO 30 PASSENGER",
      speed: "SPEED 0.25 TO 3 MPS",
      efficiency: "Available in Gearless Motor",
      address: "New York, 57 Madison Ave",
      phone: "+12345 - 600 - 990",
      fax: "1234 - 11111 - 002",
      email: "support@passengerelevators.com",
      socialLinks: [],
      contactImage: passengerElevatorImg3,
    },
    details: {
      mainImage: passengerElevatorImg5,
      image: passengerElevatorImg1,
      title: "Comfort meets convenience with care",
      text1: "A modern passenger elevator designed for universal accessibility and sustainability, integrating eco-friendly practices and offering options for gearless, geared, or hydraulic systems. It caters especially well to densely populated urban buildings. The elevator ensures a smooth and quiet ride with vibration control, advanced leveling systems, and intuitive accessibility features. It meets energy efficiency standards while maintaining high safety and comfort for all users.",
      points: [
        "Different types of door available.",
        "Jerk-less travelling.",
        "Customisable car interiors",
        "Available in gearless motor"
      ],
      text3: "Perfect for office, residential and commercial buildings.",
      tableData: [],
    },
  },
  {
    id: "premium-passenger-elevators",
    basicInfo: {
      image: projectImg3,
      liftType: "Passenger Elevators",
      tagline: "Premium Passenger Rides",
      passengerSize: "6 TO 30 PASSENGER",
      speed: "SPEED 0.63 TO 3 MPS",
      efficiency: "Fully Automatic",
      address: "New York, 57 Madison Ave",
      phone: "+12345 - 600 - 990",
      fax: "1234 - 11111 - 002",
      email: "support@passengerelevators.com",
      socialLinks: [],
      contactImage: passengerLiftLargeImage,
    },
    details: {
      mainImage: premiumElevatorImg2,
      image: projectImg3,
      title: "Premium Elevator",
      text1: "Architectural flexibility seamlessly integrates into various building designs, enhancing aesthetic appeal while providing efficient and stylish vertical transportation. These lifts can be customized with luxurious finishes like polished metal or premium wood, making them ideal for high-end environments. Safety is a top priority, with robust mechanisms ensuring reliability. Modern features such as touch-screen panels and smart controls enhance user experience, delivering a refined blend of technology and elegance.",
      points: [
        "Customise your car with high-end finished materials.",
        "Eco-friendly and energy-efficient.",
        "Tactile touch panels for modern interaction.",
        "Available in gearless motor",
      ],
      text3: "",
      tableHeader: "Dimension of Passenger Lift",
      tableData: `<table class="arch-table">
  <thead>
    <tr>
      <th>Passenger</th>
      <th>Load (kg)</th>
      <th>Area (m²)</th>
      <th>Lift Well Size (W × D mm)</th>
      <th>Lift Well Area (m²)</th>
      <th>Entrance (mm)</th>
      <th>Machine Room Area (m²)</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>6</td>
      <td>408</td>
      <td>1.10</td>
      <td>1800 × 1700</td>
      <td>3.04</td>
      <td>800</td>
      <td>13.94</td>
    </tr>
    <tr>
      <td>8</td>
      <td>544</td>
      <td>1.43</td>
      <td>1900 × 1900</td>
      <td>3.61</td>
      <td>800</td>
      <td>14.96</td>
    </tr>
    <tr>
      <td>10</td>
      <td>680</td>
      <td>1.75</td>
      <td>1900 × 2100</td>
      <td>3.99</td>
      <td>800</td>
      <td>15.64</td>
    </tr>
    <tr>
      <td>13</td>
      <td>884</td>
      <td>2.20</td>
      <td>2100 × 2500</td>
      <td>5.25</td>
      <td>900</td>
      <td>18.40</td>
    </tr>
    <tr>
      <td>16</td>
      <td>1088</td>
      <td>2.20</td>
      <td>2100 × 2500</td>
      <td>5.25</td>
      <td>1000</td>
      <td>18.40</td>
    </tr>
    <tr>
      <td>20</td>
      <td>1360</td>
      <td>3.10</td>
      <td>2200 × 2750</td>
      <td>6.00</td>
      <td>1000</td>
      <td>19.60</td>
    </tr>
    <tr>
      <td>26</td>
      <td>1768</td>
      <td>3.87</td>
      <td>2600 × 2800</td>
      <td>7.24</td>
      <td>1200</td>
      <td>23.92</td>
    </tr>
    <tr>
      <td>30</td>
      <td>2040</td>
      <td>4.18</td>
      <td>2710 × 2900</td>
      <td>7.62</td>
      <td>1200</td>
      <td>23.92</td>
    </tr>
  </tbody>
</table>
`,
    },
  },
  {
    id: "classic-passenger-elevators",
    basicInfo: {
      image: projectImg4,
      liftType: "Passenger Elevators",
      tagline: "Classic Passenger Rides",
      passengerSize: "6 TO 30 PASSENGER",
      speed: "SPEED 0.63 TO 3 MPS",
      efficiency: "Fully Automatic",
      address: "New York, 57 Madison Ave",
      phone: "+12345 - 600 - 990",
      fax: "1234 - 11111 - 002",
      email: "support@passengerelevators.com",
      socialLinks: [],
      contactImage: classicElevatorImg1,
    },
    details: {
      mainImage: classicElevator,
      image: projectImg4,
      title: "Classic Passenger Elevator",
      text1: "Classic elevators are designed to meet the vertical transportation needs of urban and suburban environments. They ensure easy access between floors, enhancing mobility for all residents. In office buildings and shopping malls, they support the smooth movement of large crowds, boosting efficiency and user satisfaction. Built with reliable safety mechanisms, classic elevators deliver consistent performance under diverse usage conditions. By improving accessibility and operational efficiency, they contribute to better urban infrastructure and the quality of life in cities.",
      points: [
        "Eco-friendly and energy-efficient.",
        "Enhanced user experience with micro-stroke panels.",
        "Ideal for high-traffic buildings like malls and offices.",
        "Built to support dynamic urban lifestyles."
      ],
      text3: "Perfect for office, residential and commercial buildings.",
      tableData: `<table class="arch-table">
  <thead>
    <tr>
      <th>Passenger</th>
      <th>Load (kg)</th>
      <th>Area (m²)</th>
      <th>Lift Well Size (W × D mm)</th>
      <th>Lift Well Area (m²)</th>
      <th>Entrance (mm)</th>
      <th>Machine Room Area (m²)</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>6</td>
      <td>408</td>
      <td>1.10</td>
      <td>1800 × 1700</td>
      <td>3.04</td>
      <td>800</td>
      <td>13.94</td>
    </tr>
    <tr>
      <td>8</td>
      <td>544</td>
      <td>1.43</td>
      <td>1900 × 1900</td>
      <td>3.61</td>
      <td>800</td>
      <td>14.96</td>
    </tr>
    <tr>
      <td>10</td>
      <td>680</td>
      <td>1.75</td>
      <td>1900 × 2100</td>
      <td>3.99</td>
      <td>800</td>
      <td>15.64</td>
    </tr>
    <tr>
      <td>13</td>
      <td>884</td>
      <td>2.20</td>
      <td>2100 × 2500</td>
      <td>5.25</td>
      <td>900</td>
      <td>18.40</td>
    </tr>
    <tr>
      <td>16</td>
      <td>1088</td>
      <td>2.20</td>
      <td>2100 × 2500</td>
      <td>5.25</td>
      <td>1000</td>
      <td>18.40</td>
    </tr>
    <tr>
      <td>20</td>
      <td>1360</td>
      <td>3.10</td>
      <td>2200 × 2750</td>
      <td>6.00</td>
      <td>1000</td>
      <td>19.60</td>
    </tr>
    <tr>
      <td>26</td>
      <td>1768</td>
      <td>3.87</td>
      <td>2600 × 2800</td>
      <td>7.24</td>
      <td>1200</td>
      <td>23.92</td>
    </tr>
    <tr>
      <td>30</td>
      <td>2040</td>
      <td>4.18</td>
      <td>2710 × 2900</td>
      <td>7.62</td>
      <td>1200</td>
      <td>23.92</td>
    </tr>
  </tbody>
</table>
`,
    },
  },
  {
    id: "capsule-elevators",
    basicInfo: {
      image: capsuleLiftImg1,
      liftType: "Passenger Elevators",
      tagline: "Capsule Elevators",
      passengerSize: "6 TO 30 PASSENGER",
      speed: "SPEED 0.63 TO 3 MPS",
      efficiency: "Semi circular or Diamond shaped elevator",
      address: "New York, 57 Madison Ave",
      phone: "+12345 - 600 - 990",
      fax: "1234 - 11111 - 002",
      email: "support@passengerelevators.com",
      socialLinks: [],
      contactImage: capsuleLiftImg3,
    },
    details: {
      mainImage: capsuleLiftImg2,
      image: capsuleLiftImg3,
      title: "Capsule Elevator",
      text1: "Capsule elevators are not just a means of transport—they are architectural statements. With their transparent walls and panoramic views, these lifts offer a unique passenger experience that enhances the prestige and design of any building. Whether installed in skyscrapers, shopping malls, corporate offices, or luxury residences, capsule elevators serve as a centerpiece that elevates both form and function. Their sleek design seamlessly blends into modern architecture, creating memorable vertical journeys.",
      points: [
        "Eco-friendly and energy-efficient.",
        "Elegant range of professionally designed car interiors.",
        "Available in gearless motor options.",
        "Creates a lasting impression with panoramic glass design."
      ],
      text3: "Perfect for office, residential and commercial buildings.",
      tableData: `<table class="arch-table">
  <thead>
    <tr>
      <th>Passenger</th>
      <th>Load (kg)</th>
      <th>Area (m²)</th>
      <th>Lift Well Size (W × D mm)</th>
      <th>Lift Well Area (m²)</th>
      <th>Entrance (mm)</th>
      <th>Machine Room Area (m²)</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>6</td>
      <td>408</td>
      <td>1.10</td>
      <td>1800 × 1700</td>
      <td>3.04</td>
      <td>800</td>
      <td>13.94</td>
    </tr>
    <tr>
      <td>8</td>
      <td>544</td>
      <td>1.43</td>
      <td>1900 × 1900</td>
      <td>3.61</td>
      <td>800</td>
      <td>14.96</td>
    </tr>
    <tr>
      <td>10</td>
      <td>680</td>
      <td>1.75</td>
      <td>1900 × 2100</td>
      <td>3.99</td>
      <td>800</td>
      <td>15.64</td>
    </tr>
    <tr>
      <td>13</td>
      <td>884</td>
      <td>2.20</td>
      <td>2100 × 2500</td>
      <td>5.25</td>
      <td>900</td>
      <td>18.40</td>
    </tr>
    <tr>
      <td>16</td>
      <td>1088</td>
      <td>2.20</td>
      <td>2100 × 2500</td>
      <td>5.25</td>
      <td>1000</td>
      <td>18.40</td>
    </tr>
    <tr>
      <td>20</td>
      <td>1360</td>
      <td>3.10</td>
      <td>2200 × 2750</td>
      <td>6.00</td>
      <td>1000</td>
      <td>19.60</td>
    </tr>
    <tr>
      <td>26</td>
      <td>1768</td>
      <td>3.87</td>
      <td>2600 × 2800</td>
      <td>7.24</td>
      <td>1200</td>
      <td>23.92</td>
    </tr>
    <tr>
      <td>30</td>
      <td>2040</td>
      <td>4.18</td>
      <td>2710 × 2900</td>
      <td>7.62</td>
      <td>1200</td>
      <td>23.92</td>
    </tr>
  </tbody>
</table>
`,
    },
  },
  {
    id: "standard-passenger-elevators",
    basicInfo: {
      image: standardLiftImage,
      liftType: "Passenger Elevators",
      tagline: "Standard Passenger Elevators",
      passengerSize: "6 TO 30 PASSENGER",
      speed: "SPEED 0.63 TO 3 MPS",
      efficiency: "Cost Effective",
      address: "New York, 57 Madison Ave",
      phone: "+12345 - 600 - 990",
      fax: "1234 - 11111 - 002",
      email: "support@passengerelevators.com",
      socialLinks: [],
      contactImage: standardLiftImage1,
    },
    details: {
      mainImage: passengerElevatorImg4,
      image: projectImg1,
      title: "Standard Passenger Elevator",
      text1: "Standard passenger elevators offer a cost-effective solution for essential vertical mobility, particularly in mid-rise residential complexes, small offices, and community buildings. Equipped with manual doors and lower-budget geared motors, they are designed to maintain reliable performance while keeping operational and installation costs low. These elevators are perfect for suburban developments or developing regions where budget constraints are a priority. Despite their affordability, they don’t compromise on basic safety, comfort, or accessibility, making them a practical choice for everyday transport needs.",
      points: [
        "All types of doors available.",
        "Feeling with micro-stroke panel.",
        "Optimized for budget-sensitive projects.",
        "Simple maintenance and robust build for long-term reliability",
      ],
      text3: "Perfect for office, residential and commercial buildings.",
      tableData: `<table class="arch-table">
  <thead>
    <tr>
      <th>Passenger</th>
      <th>Load (kg)</th>
      <th>Area (m²)</th>
      <th>Lift Well Size (W × D mm)</th>
      <th>Lift Well Area (m²)</th>
      <th>Entrance (mm)</th>
      <th>Machine Room Area (m²)</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>6</td>
      <td>408</td>
      <td>1.10</td>
      <td>1800 × 1700</td>
      <td>3.04</td>
      <td>800</td>
      <td>13.94</td>
    </tr>
    <tr>
      <td>8</td>
      <td>544</td>
      <td>1.43</td>
      <td>1900 × 1900</td>
      <td>3.61</td>
      <td>800</td>
      <td>14.96</td>
    </tr>
    <tr>
      <td>10</td>
      <td>680</td>
      <td>1.75</td>
      <td>1900 × 2100</td>
      <td>3.99</td>
      <td>800</td>
      <td>15.64</td>
    </tr>
    <tr>
      <td>13</td>
      <td>884</td>
      <td>2.20</td>
      <td>2100 × 2500</td>
      <td>5.25</td>
      <td>900</td>
      <td>18.40</td>
    </tr>
    <tr>
      <td>16</td>
      <td>1088</td>
      <td>2.20</td>
      <td>2100 × 2500</td>
      <td>5.25</td>
      <td>1000</td>
      <td>18.40</td>
    </tr>
    <tr>
      <td>20</td>
      <td>1360</td>
      <td>3.10</td>
      <td>2200 × 2750</td>
      <td>6.00</td>
      <td>1000</td>
      <td>19.60</td>
    </tr>
    <tr>
      <td>26</td>
      <td>1768</td>
      <td>3.87</td>
      <td>2600 × 2800</td>
      <td>7.24</td>
      <td>1200</td>
      <td>23.92</td>
    </tr>
    <tr>
      <td>30</td>
      <td>2040</td>
      <td>4.18</td>
      <td>2710 × 2900</td>
      <td>7.62</td>
      <td>1200</td>
      <td>23.92</td>
    </tr>
  </tbody>
</table>
`,
    },
  },
  {
    id: "hydraulic-elevators",
    basicInfo: {
      image: hydraulicElevatorImg1,
      liftType: "Hydraulic Elevators",
      tagline: "Hydraulic Smooth Ride",
      passengerSize: "2 TO 6 PASSENGER",
      speed: "SPEED 0.2 TO 0.5 MPS",
      efficiency: "MINIMUM OVERHEAD",
      address: "Los Angeles, Sunset Blvd",
      phone: "+14567 - 100 - 777",
      fax: "1234 - 58963 - 010",
      email: "info@hydraulicelevators.com",
      socialLinks: [],
      contactImage: hydraulicElevatorImg2,
    },
    details: {
      mainImage: hydraulicElevatorImg1,
      image: projectImg1,

      title: "Hydraulic power, seamless ride.",
      text1: "Hydraulic elevators use fluid pressure to lift the cab, ideal for low-rise buildings and known for smooth operation and minimal maintenance.",
      points: [
        "Cost-effective for low-rise buildings.",
        "Quiet and smooth lift operation.",
        "Simple machine room requirements.",
      ],
      text3: "A practical and efficient choice for modern buildings.",
      tableData: [],
    },
  },
  {
    id: "home-elevators",
    basicInfo: {
      image: homeElevatorImg1,
      liftType: "Home Elevators",
      tagline: "Smart Home Transport",
      passengerSize: "1 TO 4 PASSENGER",
      speed: "SPEED 0.15 TO 0.4 MPS",
      efficiency: 5,
      address: "Mumbai, India",
      phone: "+91222 - 200 - 400",
      fax: "5678 - 12345 - 987",
      email: "home@elevators.in",
      socialLinks: [],
      contactImage: homeElevatorImg2,
    },
    details: {
      mainImage: homeElevatorImg3,
      image: projectImg1,

      title: "Delivering success through logistics",
      text1: "Home elevators provide convenience, safety, and a touch of luxury to modern multi-story residences.",
      points: [
        "Customizable cabin interiors.",
        "Compact footprint.",
        "Low energy consumption.",
      ],
      text3: "Enhance your home living experience with effortless vertical access.",
      tableData: [],
    },
  },
  {
    id: "hospital-elevators",
    basicInfo: {
      image: hospitalElevatorImg1,
      liftType: "Hospital Elevators",
      tagline: "Medical Grade Access",
      passengerSize: "12 TO 30 PASSENGER",
      speed: "SPEED 0.63 TO 2 MPS",
      efficiency: "Available in Gearless Motor",
      address: "Bangalore, India",
      phone: "+91888 - 300 - 700",
      fax: "8888 - 12345 - 333",
      email: "support@hospitalelevators.com",
      socialLinks: [],
      contactImage: hospitalElevatorImg3,
    },
    details: {
      mainImage: hospitalElevatorImg2,
      image: projectImg1,

      title: "Healing journeys made smoother",
      text1: "Hospital elevators are built for transporting patients, staff, and medical equipment with precision and safety.",
      points: [
        "Spacious cabins for stretchers and beds.",
        "Anti-bacterial interiors.",
        "Backup power for emergencies.",
      ],
      text3: "Because every second matters in healthcare environments.",
      tableData: [],
    },
  },
  {
    id: "service-elevators",
    basicInfo: {
      image: serviceLiftImg1,
      liftType: "Service Elevators",
      tagline: "Industrial-Grade Reliability",
      passengerSize: "5 TO 20 PASSENGER",
      speed: "SPEED 0.5 TO 2.0 MPS",
      efficiency: 5,
      address: "Pune, India",
      phone: "+91777 - 400 - 800",
      fax: "5678 - 22222 - 456",
      email: "service@elevators.com",
      socialLinks: [],
      contactImage: serviceLiftImg2,
    },
    details: {
      mainImage: serviceLiftImg3,
      image: projectImg1,

      title: "Elevating your service standards.",
      text1: "Service elevators are designed for transporting goods, equipment, and maintenance personnel efficiently and securely.",
      points: [
        "Heavy-duty construction.",
        "High load capacity.",
        "Durable interior finishes.",
      ],
      text3: "Ideal for hotels, malls, and industrial settings.",
      tableData: [],
    },
  },
  {
    id: "goods-elevators",
    basicInfo: {
      image: goodsLiftImg1,
      liftType: "Goods Elevators",
      tagline: "Heavy Duty Lifting",
      passengerSize: "Up to 5000 KG",
      speed: "SPEED 0.2 TO 1.0 MPS",
      efficiency: 5,
      address: "Ahmedabad, India",
      phone: "+91666 - 555 - 333",
      fax: "9999 - 33333 - 789",
      email: "goods@elevators.com",
      socialLinks: [],
      contactImage: goodsElevatorImg2,
    },
    details: {
      mainImage: goodsElevatorImg,
      image: projectImg1,

      title: "Built to move heavy loads with efficiency",
      text1: "Goods elevators are built for high capacity lifting in warehouses, factories, and industrial environments.",
      points: [
        "Rugged steel construction.",
        "Smooth and stable ride under load.",
        "Optional collapsible gates.",
      ],
      text3: "Move your goods quickly and safely.",
      tableData: [],
    },
  },
  {
    id: "car-elevators",
    basicInfo: {
      image: carElevatorImg1,
      liftType: "Car Elevators",
      tagline: "Auto Parking Solutions",
      passengerSize: "3000 TO 5000 KG",
      speed: "SPEED 0.25 TO 0.75 MPS",
      efficiency: 5,
      address: "Delhi NCR, India",
      phone: "+91999 - 100 - 222",
      fax: "8888 - 44444 - 111",
      email: "car@elevators.com",
      socialLinks: [],
      contactImage: carElevatorImg3,
    },
    details: {
      mainImage: carelevatorImg2,
      image: projectImg1,

      title: "Lift Your Parking Worries Away with Car Elevators!",
      text1: "Car elevators are the ideal solution for buildings with limited parking space, enabling vertical vehicle transportation.",
      points: [
        "Automatic door synchronization.",
        "Remote operation capability.",
        "Hydraulic or traction systems.",
      ],
      text3: "The future of urban vehicle mobility.",
      tableData: [],
    },
  },
  {
    id: "stack-parking",
    basicInfo: {
      image: projectImg5,
      liftType: "Stack Parking",
      tagline: "Space-Saving Tech",
      passengerSize: "2000 KGs",
      speed: "HEIGHT 1.6M - 1.8M",
      efficiency: "",
      address: "Hyderabad, India",
      phone: "+91555 - 888 - 111",
      fax: "1234 - 65432 - 321",
      email: "stack@parking.com",
      socialLinks: [],
      contactImage: stackParkingLiftImg2,
    },
    details: {
      mainImage: stackParkingLiftImg1,
      image: projectImg5,

      title: "Space-Saving Solutions for Urban Living!",
      text1: "Stack parking systems are the ultimate solution for densely populated urban spaces where traditional parking isn’t feasible. By utilizing vertical space, these systems double parking capacity without requiring extensive construction. \n Designed for residential towers, commercial hubs, and public parking facilities, stack parking systems are modular, low-maintenance, and quick to install. With integrated pallet locking for safety and compatibility with various vehicle sizes, they deliver dependable performance and long-term value.",
      points: [
        "Modular Design for Easy Installation & Maintenance.",
        "Secure Pallet Locking Mechanism for Vehicle Safety.",
        "Fits Most Passenger Cars with Flexible Dimensions.",
        "Optimized for Indoor Use in Urban Spaces."
      ],
      text3: "Compact, convenient, and cost-effective parking.",
      tableData: [],
    },
  },

  // Add 9 more projects in same format
];

export default projectList;
